
import React, { Component, Fragment } from 'react'


class ConnectLineUI extends Component {
    constructor() {
        super();
        this.line = React.createRef();
    }
    render = () => {
        this.connect()


        let { quizViewer, connectLine } = this.props
        let { quizViwerModel } = quizViewer.state


        let color = "grey"
        if (quizViwerModel.reviewMode)
            color = connectLine.getReviewColor()

        
        return (
            <Fragment>


                <div ref={this.line}


                    onClick={this.handleRemoveLine}
                    style={{
                        opacity: "0.5",  padding: "0px", margin: "0px", border: "1px " + color + "  solid", height: this.thikness + "px", backgroundColor: color, lineLeight: "1px", position: "absolute", left: this.cx + "px", top: this.cy + "px", width: this.length + "px",
                        MozTransform: "rotate(" + this.angle + "deg)", WebkitTransform: "rotate(" + this.angle + "deg)", OTransform: "rotate(" + this.angle + "deg)", MsTransform: "rotate(" + this.angle + "deg)", transform: "rotate(" + this.angle + "deg)"
                    }}>

                </div>

            </Fragment>
        )
    }


    handleRemoveLine = () => {
        
        let { activity, quizViewer, connectLine } = this.props
        // this.line.current.remove();
        let connectLines = activity.lineList

        activity.lineList = connectLines.filter(function (item, index) {
            return item.lineIndex != connectLine.lineIndex
        });
        quizViewer.setState({})


    }



    connect = () => {
        let { connectLine } = this.props
        let div1 = connectLine.sourceItem.htmlRef
        let div2 = connectLine.targetItem.htmlRef

        this.thickness = 0.5;

        var off1 = this.getOffsetSource(div1);
        var off2 = this.getOffsetTarget(div2);

        console.log(off1.left + " " + div1.className)
        console.log(off2.left + " " + div2.className)

        console.log(off1.top + " " + div1.className)
        console.log(off2.top + " " + div2.className)



        // bottom right
        var x1 = off1.left-35  // / factor;
        var y1 = (off1.top + off1.height / 2) /// factor;

        // top right
        var x2 = (off2.left + off2.width)+35 // / factor;
        var y2 = (off2.top + off2.height / 2) // / factor;

        // distance
        this.length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
        // center
        this.cx = (((x1 + x2) / 2) - (this.length / 2));
        this.cy = (((y1 + y2) / 2) - (this.thickness / 2));
        // angle
        this.angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);


    }



    getOffset = (el) => {

        var rect = el.getBoundingClientRect();
        return {
            left: el.offsetLeft,
            top: el.offsetTop,
            width: el.offsetWidth,
            height: rect.height,
            padding: el.offsetWidth - rect.width
        };



    }

    getOffsetSource = (el) => {

        var rect = el.getBoundingClientRect();

        return {
            left: el.offsetLeft + el.offsetWidth,
            top: el.offsetTop,
            width: el.offsetWidth,
            height: rect.height,
            padding: el.offsetWidth - rect.width
        };

        // var rect = el.getBoundingClientRect();
        // return {
        //     left: rect.left,
        //     top: rect.top,
        //     width: rect.width,
        //     height: rect.height
        // };

    }

    getOffsetTarget = (el) => {

        var rect = el.getBoundingClientRect();

        return {
            left: el.offsetLeft - el.offsetWidth,
            top: el.offsetTop,
            width: el.offsetWidth,
            height: rect.height,
            padding: el.offsetWidth - rect.width
        };



    }
}

export default ConnectLineUI